import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "#1A1B1F",
  "clip-path": "url(#a)"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16.875 10.475v-.956l1.2-1.05a1.25 1.25 0 0 0 .238-1.594l-1.476-2.5a1.25 1.25 0 0 0-1.08-.625 1.3 1.3 0 0 0-.4.063l-1.52.512a7 7 0 0 0-.818-.469L12.7 2.281a1.25 1.25 0 0 0-1.25-1.006H8.525a1.25 1.25 0 0 0-1.25 1.006l-.319 1.575q-.427.207-.825.469l-1.487-.537a1.3 1.3 0 0 0-.4-.038 1.25 1.25 0 0 0-1.082.625l-1.475 2.5a1.25 1.25 0 0 0 .257 1.569l1.181 1.081v.956l-1.181 1.05a1.25 1.25 0 0 0-.257 1.594l1.475 2.5a1.25 1.25 0 0 0 1.082.625q.204.002.4-.063l1.518-.512q.394.26.82.469l.318 1.575a1.25 1.25 0 0 0 1.25 1.006h2.95a1.25 1.25 0 0 0 1.25-1.006l.319-1.575q.428-.208.825-.469l1.512.512a1.25 1.25 0 0 0 1.481-.563l1.425-2.499a1.25 1.25 0 0 0-.256-1.569zM15.756 15l-2.143-.725a5.5 5.5 0 0 1-1.694.981l-.444 2.244h-2.95l-.444-2.219a5.9 5.9 0 0 1-1.687-.981l-2.15.7-1.475-2.5 1.7-1.5a5.6 5.6 0 0 1 0-1.956L2.769 7.5 4.244 5l2.143.725a5.5 5.5 0 0 1 1.694-.981L8.525 2.5h2.95l.444 2.219a5.9 5.9 0 0 1 1.687.981l2.15-.7 1.475 2.5-1.7 1.5a5.5 5.5 0 0 1 0 1.956l1.7 1.544z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M10 13.75A3.75 3.75 0 1 1 13.75 10 3.714 3.714 0 0 1 10 13.75m0-6.25A2.444 2.444 0 0 0 7.5 10a2.444 2.444 0 0 0 2.5 2.5 2.444 2.444 0 0 0 2.5-2.5A2.444 2.444 0 0 0 10 7.5" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }